import React from 'react';
import './Loader.css';

export default props => <div className="loader">Loading...</div>



// WEBPACK FOOTER //
// ./src/components/Loader.js